export default "__VITE_ASSET__Dt$qStiL__"